import { useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import {
  setSession,
  setEmailSession,
  setQualtricsQuestions,
  setEmailQualtricsQuestions,
  addResponse,
  addEmailResponse,
  addResponses,
} from '../redux/slices/qualtricsSurveySlice'
import { 
  setSubmitMultiSelectAnswerLoading,
  setSubmitMultipleChoiceAnswerLoading,
  setSubmitBulkMultipleChoiceAnswersLoading,
  setSubmitSingleAnswerLoading,
} from '../redux/slices/globalSlice'
import { isNil, forOwn } from 'lodash'

const LANGUAGES = {
  'en-US': 'EN',
  'es': 'ES',
}

const useQualtricsSurvey = () => {
  const dispatch = useDispatch()
  const session = useSelector(({ qualtricsSurvey }) => qualtricsSurvey.session)
  // const emailSession = useSelector(({ qualtricsSurvey }) => qualtricsSurvey.emailSession)
  const selectedLanguage = useSelector(({ language }) => language.value)
  const isLoading = useRef(false)
  const [hasError, setHasError] = useState(false)
  const [hasSessionError, setHasSessionError] = useState(false)
  const {
    // isRandomSample,
    realIp,
    submitMultiSelectAnswerLoading,
    submitMultipleChoiceAnswerLoading,
    submitBulkMultipleChoiceAnswersLoading,
    submitSingleAnswerLoading,
  } = useSelector(({ global }) => global)

  const createSurveySession = async ({ cb, lang, isRandomSample, id }) => {
    isLoading.current = true
    setHasError(false)
    setHasSessionError(false)

    try {
      const embeddedData = {
        language: lang || selectedLanguage,
      }
      if (isRandomSample) embeddedData.Is_Random_Sample = 'Yes'
      if (id) embeddedData.Referrer_Id = id
      const data = require('../data/qualtrics_1.json')
      // const response = await axios.request({
      //   method: 'POST',
      //   url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions`,
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
      //   },
      //   data: {
      //     language: LANGUAGES[lang] || LANGUAGES[selectedLanguage],
      //     embeddedData,
      //   },
      // })

      dispatch(setSession(data?.result?.sessionId))
      dispatch(setQualtricsQuestions(data?.result?.questions))
      cb?.(data?.result?.sessionId)
    } catch (error) {
      console.error(error)
      setHasSessionError(true)
      cb?.()
    } finally {
      isLoading.current = false
      // cb?.()
    }
  }

  const createEmailSurveySession = async (cb) => {
    isLoading.current = true
    setHasError(false)

    try {
      const response = await axios.request({
        method: 'POST',
        url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_EMAIL_SURVEY_ID}/sessions`,
        headers: {
          'Content-Type': 'application/json',
          'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
        },
        data: {
          language: LANGUAGES[selectedLanguage],
          embeddedData: { 
            language: selectedLanguage,
            Actual_IP_Address: realIp,
          },
        },
      })

      dispatch(setEmailSession(response?.data?.result?.sessionId))
      dispatch(setEmailQualtricsQuestions(response?.data?.result?.questions))
      cb?.(response?.data?.result?.sessionId)
    } catch (error) {
      console.error(error)
      setHasError(true)
    } finally {
      isLoading.current = false
    }
  }

  const submitMultiSelectAnswer = async (questionId, choiceId, answer, responses) => {
    if (!session) return
    // dispatch(setSubmitMultiSelectAnswerLoading(true))

    dispatch(addResponse({ questionId: [`${questionId}_${choiceId}`], answer }))

    let formattedResponses = {
      [questionId]: {},
    }

    forOwn(responses, function(responseAnswer, responseQuestionId) {
      let splitId = responseQuestionId.split('_')

      if (splitId.length !== 1 && splitId?.[0] === questionId) {
        let [qId, responseChoiceId] = splitId
        formattedResponses[qId][responseChoiceId] = { selected: responseAnswer }
      }
    })

    formattedResponses[questionId][choiceId] = { selected: answer }

    // try {
    //   return axios.request({
    //     method: 'POST',
    //     url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions/${session}`,
    //     headers: {
    //       'Content-Type': 'application/json', 
    //       'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
    //     },
    //     data: {
    //       language: LANGUAGES[selectedLanguage],
    //       embeddedData: { 
    //         language: selectedLanguage,
    //       },
    //       advance: false,
    //       responses: formattedResponses,
    //     }
    //   }).then(() => {
    //     dispatch(setSubmitMultiSelectAnswerLoading(false))
    //   })
    // } catch (error) {
    //   console.error(error)
    //   dispatch(setSubmitMultiSelectAnswerLoading(false))
    // }
  }

  const submitMultipleChoiceAnswer = async (questionId, answer, stateAnswer, textAnswer) => {
    if (!session) return

    dispatch(addResponse({ questionId, answer: isNil(stateAnswer) ? answer : stateAnswer }))

    // try {
    //   dispatch(setSubmitMultipleChoiceAnswerLoading(true))
    //   if (answer !== null) {
    //     return axios.request({
    //       method: 'POST',
    //       url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions/${session}`,
    //       headers: {
    //         'Content-Type': 'application/json', 
    //         'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
    //       },
    //       data: {
    //         language: LANGUAGES[selectedLanguage],
    //         embeddedData: { 
    //           language: selectedLanguage,
    //         },
    //         advance: false,
    //         responses: {
    //           [questionId]: {
    //             [answer]: { 
    //               selected: true,
    //               text: textAnswer,
    //             },
    //           },
    //         },
    //       }
    //     }).then(() => {
    //       dispatch(setSubmitMultipleChoiceAnswerLoading(false))
    //     })
    //   }
    //   dispatch(setSubmitMultipleChoiceAnswerLoading(false))
    // } catch (error) {
    //   console.error(error)
    //   dispatch(setSubmitMultipleChoiceAnswerLoading(false))
    // }
  }

  const submitBulkMultipleChoiceAnswers = async (questionIds, answers, stateAnswers) => {
    if (!session) return

    dispatch(addResponses({ questionIds, answers: isNil(stateAnswers) ? answers : stateAnswers }))

    const responses = {}

    questionIds.forEach((o, idx) => {
      responses[o] = { [answers[idx]]: { selected: true } }
    })

    // try {
    //   dispatch(setSubmitBulkMultipleChoiceAnswersLoading(true))
    //   return axios.request({
    //     method: 'POST',
    //     url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions/${session}`,
    //     headers: {
    //       'Content-Type': 'application/json', 
    //       'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
    //     },
    //     data: {
    //       language: LANGUAGES[selectedLanguage],
    //       embeddedData: { 
    //         language: selectedLanguage,
    //       },
    //       advance: false,
    //       responses,
    //     }
    //   }).then(() => {
    //     dispatch(setSubmitBulkMultipleChoiceAnswersLoading(false))
    //   })
    // } catch (error) {
    //   console.error(error)
    //   dispatch(setSubmitBulkMultipleChoiceAnswersLoading(false))
    // }
  }

  const submitSingleAnswer = async (questionId, answer, stateAnswer) => {
    if (!session) return

    dispatch(addResponse({ questionId, answer: isNil(stateAnswer) ? answer : stateAnswer }))

    // try {
    //   dispatch(setSubmitSingleAnswerLoading(true))
    //   return await axios.request({
    //     method: 'POST',
    //     url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions/${session}`,
    //     headers: {
    //       'Content-Type': 'application/json', 
    //       'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
    //     },
    //     data: {
    //       language: LANGUAGES[selectedLanguage],
    //       embeddedData: { 
    //         language: selectedLanguage,
    //       },
    //       advance: false,
    //       responses: {
    //         [questionId]: answer,
    //       },
    //     }
    //   }).then(() => {
    //     dispatch(setSubmitSingleAnswerLoading(false))
    //   })
    // } catch (error) {
    //   console.error(error)
    //   dispatch(setSubmitSingleAnswerLoading(false))
    // }
  }

  const submitSingleEmailAnswer = async (sesh, questionId, answer, score) => {
    
    if (!sesh) return

    return await axios.request({
      method: 'POST',
      url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_EMAIL_SURVEY_ID}/sessions/${sesh}`,
      headers: {
        'Content-Type': 'application/json', 
        'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
      },
      data: {
        language: LANGUAGES[selectedLanguage],
        embeddedData: { 
          language: selectedLanguage,
          // Q_RecaptchaScore: score.toString(),
        },
        advance: true, // close hack
        responses: {
          [questionId]: answer,
        },
      }
    })
  }

  const advanceSurvey = async ({ cb, score, ip, nextIndex }, questionId, answer, stateAnswer) => {
    if (!session) return

    let responses = {}
    if (questionId && answer?.length) { // temp for string
      dispatch(addResponse({ questionId, answer: isNil(stateAnswer) ? answer : stateAnswer }))
      responses[questionId] = answer
    }

    isLoading.current = true
    setHasError(false)
    
    try {
      const data = require(`../data/qualtrics_${nextIndex}.json`)
      // const response = await axios.request({
      //   method: 'POST',
      //   url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions/${session}`,
      //   headers: {
      //     'Content-Type': 'application/json', 
      //     'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
      //   },
      //   data: {
      //     language: LANGUAGES[selectedLanguage],
      //     embeddedData: { 
      //       language: selectedLanguage,
      //       // Q_RecaptchaScore: score.toString(),
      //       // ...(ip ? { Actual_IP_Address: ip } : {})
      //     },
      //     // responses,
      //     advance: true,
      //   },
      // })
      cb?.()
      dispatch(setQualtricsQuestions(data?.result?.questions))
    } catch (error) {
      console.error(error)
      setHasError(true)
      cb?.(error)
    } finally {
      isLoading.current = false
    }
  }

  const resetSurveyActiveTimer = async (cb) => {
    if (!session) return

    let responses = {}
    isLoading.current = true
    setHasError(false)

    try {
      const response = await axios.request({
        method: 'POST',
        url: `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/surveys/${process.env.REACT_APP_QUALTRICS_SURVEY_ID}/sessions/${session}`,
        headers: {
          'Content-Type': 'application/json',
          'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
        },
        data: {
          language: LANGUAGES[selectedLanguage],
          embeddedData: {
            language: selectedLanguage,
          },
          // responses,
          advance: false,
        },
      })
      cb?.()
    } catch (error) {
      console.error(error)
      setHasError(true)
      cb?.(error)
    } finally {
      isLoading.current = false
    }
  }

  const completeSurvey = async () => {
    if (!session) return

    axios.request(
      `https://${process.env.REACT_APP_QUALTRICS_API_DOMAIN}/API/v3/sessions/${session}/responses/complete`,
      {},
      {
        headers: {
          'X-API-TOKEN': process.env.REACT_APP_QUALTRICS_API_TOKEN,
        },
        data: {
          language: LANGUAGES[selectedLanguage],
          embeddedData: { 
            language: selectedLanguage,
          },
          close: true,
        },
      }
    )
    dispatch(setSession(null))
  }

  return { 
    session, 
    createSurveySession,
    createEmailSurveySession,
    submitMultiSelectAnswer,
    submitMultipleChoiceAnswer, 
    submitBulkMultipleChoiceAnswers,
    submitSingleAnswer,
    submitSingleEmailAnswer,
    advanceSurvey, 
    resetSurveyActiveTimer,
    completeSurvey,
    hasError,
    hasSessionError,
    qualtricsLoading: submitMultiSelectAnswerLoading || submitMultipleChoiceAnswerLoading || submitBulkMultipleChoiceAnswersLoading || submitSingleAnswerLoading,
  }
}

export default useQualtricsSurvey
